


















import { GQL_invoice_invoice_invoiceOverdueNotices } from '@/queries/__generated__/invoice';
import { Component, Vue, Prop, Inject } from 'vue-property-decorator';
import Invoice from './Invoice.vue';

@Component
export default class InvoiceOverdueNoticeLine extends Vue {
  @Prop() private notice!: GQL_invoice_invoice_invoiceOverdueNotices;
  @Inject() public documentComponent!: Invoice;

  public get colspan() {
    let colspan = 7;
    if (this.documentComponent.displaySettings.invoiceLineOrderedQuantity) colspan += 1;
    if (this.documentComponent.displayLineAllowanceChargeColumn) colspan += 1;
    if (this.documentComponent.displaySettings.invoiceLineTaxAmount) colspan += 1;
    return colspan;
  }
}
